import ChartHersenletsel from "../../../../src/client/examples/json/hersenletsel-bij-kinderen-tot-16-jaar.json";
import * as React from 'react';
export default {
  ChartHersenletsel,
  React
};